module.exports = __webpack_public_path__ + "img/cmcc.a10ff895.png";